const getData = url => async () => {
    const res = await fetch(url)
    const json = await res.json()
    return json
}

const getProjects = getData('https://snt-backend.herokuapp.com/api/getProjects')

export { getProjects }